import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const STORAGE_KEY = "tdf_user_token";

const UserAuthCtx = createContext(null);

export function UserAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY));
  const [user, setUser] = useState(null);     // null = unknown, object = signed in, false = signed out
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (t) => {
    const use = t ?? token;
    if (!use) { setUser(false); setLoading(false); return; }
    try {
      const r = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${use}` } });
      setUser(r.data);
    } catch {
      setUser(false); setToken(null); localStorage.removeItem(STORAGE_KEY);
    } finally { setLoading(false); }
  }, [token]);

  useEffect(() => { refresh(); /* eslint-disable-line */ }, []);

  function signInWithToken(t) {
    localStorage.setItem(STORAGE_KEY, t);
    setToken(t);
    setLoading(true);
    return refresh(t);
  }
  function signOut() {
    localStorage.removeItem(STORAGE_KEY);
    setToken(null); setUser(false);
  }
  function hasEntitlement(name) {
    // Staff-preview reviewers (QA, CPD accrediting body) get access to every
    // course/tool regardless of what's on their entitlements array. Mirrors
    // the backend bypass in courses_module._ensure_entitlement.
    if (user && user.staff_preview) return true;
    return !!(user && user.entitlements && user.entitlements.includes(name));
  }
  const isStaffPreview = () => !!(user && user.staff_preview);

  return (
    <UserAuthCtx.Provider value={{ token, user, loading, signInWithToken, signOut, hasEntitlement, isStaffPreview, refresh }}>
      {children}
    </UserAuthCtx.Provider>
  );
}

export function useUserAuth() { return useContext(UserAuthCtx); }
